module.exports = __webpack_public_path__ + "img/30.105b76dd.jpg";